import { round } from 'lodash';
import React from 'react';
import {
  DataForDesignDrawingsManifold,
  DataForDesignDrawingsRoom,
} from '../../designs/data-for-design-drawings/dataForDesignDrawingsResponse';
import { DisplayStyle } from './templates/DisplayStyle';
import { PortOrRoomRow } from './templates/PortOrRoomRow';

type Props = {
  manifold: DataForDesignDrawingsManifold;
  displayStyle?: DisplayStyle;
};
export const MaxDesignFloorTemperature = ({ manifold, displayStyle = 'PerPort' }: Props) => {
  const getValue = (room: DataForDesignDrawingsRoom) =>
    room.heatLossAndHeatOutput == null || isNaN(room.heatLossAndHeatOutput.floorTemperatureInDegreesCelsius)
      ? ''
      : round(room.heatLossAndHeatOutput.floorTemperatureInDegreesCelsius, 1);

  return (
    <PortOrRoomRow
      name="Maximum Design Floor Surface Temperature (°C)"
      manifold={manifold}
      getValue={getValue}
      displayStyle={displayStyle}
    />
  );
};
